import { useContext, useRef, useEffect, Fragment } from "react";
import Main from "../../Main/components";
import { APPLICATION_NAME, MAIN_ID } from "../../util/constants";
import {
  withOSUTheming,
  useDarkMode,
  withPageHeading,
  PageHeadingContext,
} from "@osu/react-ui";
import { Navbar as OSUNavBar } from "@osu/navbar";
import Footer from "@osu/footer";
import Navbar from "../../Navbar/components";
import "../styles/index.scss";
import DocumentHead from "../../DocumentHead";
import { Outlet } from "react-router-dom";
import useAuthenticationSync from "../../Authentication/hooks/useAuthenticationSync";
import useLogOutOnIdle from "../../Authentication/hooks/useLogOutOnIdle";
import usePageTitleFromRouting from "../../_configuration/routing/hooks/usePageTitleFromRouting"
import usePageTrackingWithObserver from "../../Analytics/hooks/usePageTrackingWithObserver";

export function CoreApp({ children }) {
  const { darkMode } = useDarkMode();
  const footerRef = useRef();
  return (
    <Fragment>
      <DocumentHead />
      <div className="App">
        <OSUNavBar darkMode={darkMode} />
        <Navbar />
        {children}
        <Footer darkMode={darkMode} ref={footerRef} />
      </div>
    </Fragment>
  );
}

export function HydrateFallback({ children }) {
  return (
    <CoreApp>
      <main className="anchor-link" id={MAIN_ID}>
        <h1>{APPLICATION_NAME}</h1>
        <p>Loading...</p>
        {children}
      </main>
    </CoreApp>
  );
}

function App({ children }) {
  const { setApplicationName } = useContext(PageHeadingContext);
  useAuthenticationSync();
  useLogOutOnIdle()
  usePageTitleFromRouting();
  usePageTrackingWithObserver()

  useEffect(() => {
    setApplicationName(APPLICATION_NAME);
  }, [setApplicationName]);

  return (
    <CoreApp>
      <Main className="anchor-link" id={MAIN_ID}>
        {children}
        <Outlet />
      </Main>
    </CoreApp>
  );
}

export default withOSUTheming(withPageHeading(App));
